import { AxiosResponse } from "axios";
import { axiosConfigV2 } from "../../config/api/configApiv2";

export const getLearningMaterialList: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/unit-library/search`, payload);
};

export const getLearningMaterialDetail: (
  id: number
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.get(`/mooc-unit-resource-folder/unit/${id}`);
};

export const createLearningMaterial: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/mooc-unit-resource-folder/unit`, payload);
};

export const updateLearningMaterial: (
  id: number,
  payload: any
) => Promise<AxiosResponse<any>> = (id, payload) => {
  return axiosConfigV2.put(`/mooc-unit-resource-folder/unit/${id}`, payload);
};

export const updateFolder: (
  id: number,
  payload: any
) => Promise<AxiosResponse<any>> = (id, payload) => {
  return axiosConfigV2.put(`/mooc-unit-resource-folder/${id}`, payload);
};

export const deleteLearningMaterial: (
  id: number
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.delete(`mooc-unit-resource-folder/${id}`);
};

export const deleteMultipleLearningMaterials: (
  data: any
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.delete(`/mooc-unit-resource-folder`, { data });
};

export const shareLearningMaterial: (
  id: number,
  type: boolean
) => Promise<AxiosResponse<any>> = (id, type) => {
  return axiosConfigV2.post(
    `/unit-library/send-approve-unit-library/${id}/${type}`
  );
};

export const getLearningMaterialHistory: (
  id: number,
  payload: any
) => Promise<AxiosResponse<any>> = (id, payload) => {
  return axiosConfigV2.post(
    `/unit-library/unit-library-history/${id}`,
    payload
  );
};
export const approveLearningMaterial: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/unit-library/approve-unit-library`, payload);
};

export const revokeApproval: (payload: any) => Promise<AxiosResponse<any>> = (
  payload
) => {
  return axiosConfigV2.post(`/unit-library/revoke`, payload);
};

export const approveAllLearningMaterial: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/unit-library/approved-all`, payload);
};

export const saveLearningTemplate: (
  data: any
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(`/unit-library/save-unit-library-from-block`, data);
};

export const getLearningMaterialFromLibrary: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/unit-library/get-library-to-add-unit`, payload);
};

export const getEnterpriseShare: () => Promise<AxiosResponse<any>> = () => {
  return axiosConfigV2.get(`/unit-library/get-approver-enterprise`);
};

export const getSharerList: () => Promise<AxiosResponse<any>> = () => {
  return axiosConfigV2.get(`/unit-library/get-approvers`);
};

export const createLearningFolder: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/mooc-unit-resource-folder`, payload);
};

export const getFolderDetail: (id: number) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.get(`/mooc-unit-resource-folder/get-by-id/${id}`);
};

export const getOwnerList: () => Promise<AxiosResponse<any>> = () => {
  return axiosConfigV2.get(`/mooc-unit-resource-folder/get-all-user-owner`);
};

export const getSchoolOwnsList: () => Promise<AxiosResponse<any>> = () => {
  return axiosConfigV2.get(
    `/mooc-unit-resource-folder/get-all-university-of-folder`
  );
};

export const getLastEditedBy: () => Promise<AxiosResponse<any>> = () => {
  return axiosConfigV2.get(`/mooc-unit-resource-folder/get-all-user-updater`);
};

export const getAllMultiLevelUniversities: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(
    `/mooc-university/get-all-multi-level-universities`,
    payload
  );
};

export const getSharePermissionDetail: (
  id: number,
  params: any
) => Promise<AxiosResponse<any>> = (id, params) => {
  return axiosConfigV2.get(
    `/question-bank/get-share-permission/${id}?${params}`
  );
};

export const saveSharePermission: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/question-bank/share-permission`, payload);
};

export const moveItemLearningMaterial: (
  data: any
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(`/mooc-unit-resource-folder/move`, data);
};
